import { HttpStatusCode } from '@angular/common/http';
import { MonoTypeOperatorFunction, throwError, timer } from 'rxjs';
import { retry } from 'rxjs/operators';
import { IErrorStatus } from '@nimbus-library/features/shared/models/interfaces';
import { WallboardConst } from '../models/wallboard.const';

const NETWORK_ERROR_STATUS = 0;
const TRANSIENT_ERROR_STATUSES = [NETWORK_ERROR_STATUS, HttpStatusCode.RequestTimeout, HttpStatusCode.TooManyRequests];

export function isTransientError(error: IErrorStatus): boolean {
  if (!error || !('httpStatus' in error)) {
    return false;
  }

  const status = error.httpStatus;
  return status === undefined || TRANSIENT_ERROR_STATUSES.includes(status) || status >= HttpStatusCode.InternalServerError;
}

export function retryTransientErrorsOperator<TModel>(maxRetries: number = Infinity): MonoTypeOperatorFunction<TModel> {
  return retry({
    count: maxRetries,
    delay: (error: IErrorStatus, retryCount: number) =>
      isTransientError(error)
        ? timer(Math.min(retryCount * WallboardConst.transientRetry.delayStepMs, WallboardConst.transientRetry.delayMaxMs))
        : throwError(() => error),
  });
}
